import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { NumberField, TextField } from "Utils/renderField/fieldsHookForms";
import { ReajustePacasTable } from "./ReajustePacasTable";
import { useReajustePacasForm } from "../hooks/useReajustePacasForm";

export const ReajustePacasForm = ({ fila, regresar }) => {
    const hook = useReajustePacasForm(fila);

    const {
        formControl,
        formErrors,
        productoNombre,
        esConformeBodega,
        AgregarPalletNoRegistrado,
        EliminarReajustePallet,
        cargando,
    } = hook;

    const ConfirmarEliminacion = (linea) => {
        let mensaje = "Se eliminará el reajuste de este pallet y volverá a ";
        mensaje += "contar con las pacas que tiene registradas. ";
        mensaje += "¿Deseas continuar?";

        DecisionSwal(mensaje, "Sí, eliminar", "Cancelar", () =>
            EliminarReajustePallet(linea),
        );
    };

    return (
        <LoadMask loading={cargando} blur>
            <div className="reajuste-pacas__ayuda">
                <p className="mb-1 help-text-2">
                    Reajuste de <b>{productoNombre}</b>,{" "}
                    {esConformeBodega ? "conforme" : "no conforme"}.
                </p>
                <p className="mb-0 help-text-2">
                    Indique las pacas que hay <b>realmente</b> en cada pallet.
                    Los cambios se guardan al salir del campo y se aplican a la
                    existencia de bodega hasta que se cierre el inventario.
                </p>
            </div>

            <ReajustePacasTable hook={hook} onEliminar={ConfirmarEliminacion} />

            <div className="reajuste-pacas__pallet-nuevo">
                <h6 className="mb-2">Pallet no registrado en el sistema</h6>

                <div className="formulario-fields-row align-items-end">
                    <div className="formulario-field">
                        <label className="text-nowrap">Pacas</label>
                        <NumberField
                            control={formControl}
                            errors={formErrors}
                            name="pallet_nuevo.pacas"
                            decimalScale={0}
                        />
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">
                            Identificador físico
                        </label>
                        <TextField
                            control={formControl}
                            errors={formErrors}
                            name="pallet_nuevo.identificador"
                            placeholder="Opcional"
                        />
                    </div>

                    <div
                        className="formulario-field"
                        style={{ minWidth: "100px", flex: 2 }}
                    >
                        <label className="text-nowrap">Observaciones</label>
                        <TextField
                            control={formControl}
                            errors={formErrors}
                            name="pallet_nuevo.observaciones"
                            placeholder="Opcional"
                        />
                    </div>

                    <div className="formulario-field flex-grow-0">
                        <button
                            className="btn btn-secondary text-nowrap"
                            onClick={AgregarPalletNoRegistrado}
                        >
                            Agregar pallet
                        </button>
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center mt-5 gap-1rem">
                <button className="btn btn-primary" onClick={regresar}>
                    Regresar al cierre
                </button>
            </div>
        </LoadMask>
    );
};
